<style lang="scss" scoped>
::v-deep .table-container {
    max-height: calc(100vh - 220px);
    max-height: calc(var(--vh, 1vh) * 100 - 280px);
}
</style>
<template>
    <div class="px-md-60 py-16 py-md-32">

        <el-table :loading="loading" :rows="discountCodes" :structure="structure" :searchable="searchable" :meta="tableMeta" @meta-changed="(meta) => { tableMeta = meta; getFilteredDiscountCodes()  }" :server-side-sorting="true" detail="admin-codes-show">
            <template slot="search">
                <div class="col-12 col-lg-8">
                    <el-multi-search v-model="filter" :name="$t('form-elements.search')" :placeholder="$t('form-elements.search_placeholder')" :options="searchables" />
                </div>
            </template>
            <template slot="header">
                <div class="col-auto ml-auto d-flex flex-wrap align-items-start">
                    <button v-if="discountCodes.length > 0" @click="exportCodes()" class="btn btn-outline-primary-dark mr-24" :class="{ disabled : discountCodes.filter(c => c.selected).length === 0 }">
                        {{ $t('table.codes.export') }}
                    </button>
                    <router-link :to="{ name: 'admin-codes-add' }" class="btn btn-gold d-none d-md-block">
                        + {{ $t('pages.dashboard.add_code') }}
                    </router-link>
                </div>
            </template>
        </el-table>
    </div>
</template>

<script>
import { ElTable } from '@/components/tables'
import { ElMultiSearch } from '@/components/forms'
import { CsvDataService } from '@/utils/helpers'

export default {
    components: { ElTable, ElMultiSearch },
    data() {
        return {
            loading: false,
            tableMeta: { page: 1 },
            expiration: { value: 'nl', label: 'Vervaldatum' },
            reseller: { value: 'nl', label: 'Reseller' },
            searchable: ['code', 'company'],
            structure: [
                { visible: true, label: null, type: 'select', sortable: false },
                { visible: true, label: this.$t('table.codes.company'), type: 'text', key: 'description', sortable: true, size: 'small' },
                { visible: true, label: this.$t('table.codes.code'), type: 'text', key: 'code', sortable: true, size: 'small' },
                { visible: true, label: this.$t('table.codes.amount'), type: 'text', key: 'amount', prefix: '€ ', sortable: true, size: 'small' },
                { visible: true, label: this.$t('table.codes.maximum_users'), type: 'text', key: 'limit', sortable: true, size: 'xsmall' },
                { visible: true, label: this.$t('table.codes.user_count'), type: 'text', key: 'used', sortable: false, size: 'xsmall' },
                { visible: true, label: this.$t('table.codes.users_available'), type: 'text', key: 'available', sortable: false, size: 'xsmall' },
                { visible: true, label: this.$t('table.codes.created_by'), type: 'text', key: 'owner.first_name', sortable: true },
                { visible: true, label: this.$t('table.codes.valid_from'), type: 'date', key: 'start_date', sortable: true },
                { visible: true, label: this.$t('table.codes.valid_to'), type: 'date', key: 'end_date', sortable: true },
                { visible: true, label: this.$t('table.codes.created_at'), type: 'date', key: 'created_at', sortable: true },
                { visible: true, label: this.$t('table.codes.total_amount'), type: 'text', key: 'total_amount', prefix: '€ ', sortable: true },
            ],
            searchables: [],
            filter: [],
        }
    },
    mounted() {
        this.getFilteredDiscountCodes();
        this.getSearchables();
    },
    methods: {
        getFilteredDiscountCodes(tableMeta = null) {
            this.loading = true;
            this.$store.dispatch('discountCodes/readCodes', Object.assign(tableMeta ? tableMeta : this.tableMeta, { q: this.filter })).then((p) => {
                this.tableMeta = { ...this.tableMeta, ...p.meta };
                this.loading = false;
            })
        },
        getSearchables() {
            Promise.all([this.$store.dispatch('psychologists/list'), this.$store.dispatch('companies/list')]).then(([psychologists, companies]) => {
                this.searchables = [
                    {
                        type: 'psychologist',
                        values: psychologists.map(item => ({ value: item.id, label: `${item.first_name} ${item.last_name}` }))
                    },
                    {
                        type: 'company',
                        values: companies.map(item => ({ value: item.name, label: item.name }))
                    }
                ]
            })
        },
        exportCodes() {
            CsvDataService.exportToCsv('sts-discount-codes.csv', this.discountCodes.filter(c => c.selected).map(item => {
                return {
                    code: item.code,
                    amount: item.amount,
                    description: item.description,
                    start_date: item.start_date,
                    end_date: item.end_date,
                    used: item.used,
                    limit: item.limit,
                    available: item.available,
                    total_amount: item.total_amount,
                    owner_first_name: item.owner.first_name,
                    owner_last_name: item.owner.last_name,
                }
            }));
        }
    },
    computed: {
        discountCodes() {
            return this.$store.getters['discountCodes/all']
        }
    },
    watch: {
        filter: function () {
            this.getFilteredDiscountCodes({ page: 1 })
        }
    }
}
</script>
